export const COLORS = {
  accentPrimary: "accentPrimary",
  successPrimary: "successPrimary",
  dangerPrimary: "dangerPrimary",
  warningPrimary: "warningPrimary",
  surfacePrimary: "surfacePrimary",
  surfaceSecondary: "surfaceSecondary",
  dividerPrimary: "dividerPrimary",
  textPrimary: "textPrimary",
  textSecondary: "textSecondary",
  whitePrimary: "whitePrimary",
  blackPrimary: "blackPrimary",
  highlightPrimary: "highlightPrimary",
  ratePrimary: "ratePrimary",
  grayPrimary: "grayPrimary",
  scrollerPrimary: "scrollerPrimary",
}

export const LIGHT_PALETTE = {
  [COLORS.accentPrimary]: "#2194FF",
  [COLORS.successPrimary]: "#5BB849",
  [COLORS.dangerPrimary]: "#FF495C",
  [COLORS.warningPrimary]: "#FFB800",
  [COLORS.surfacePrimary]: "#F3F3F3",
  [COLORS.surfaceSecondary]: "#FFFFFF",
  [COLORS.dividerPrimary]: "#CED0D0",
  [COLORS.textPrimary]: "#151E22",
  [COLORS.textSecondary]: "#6B7173",
  [COLORS.whitePrimary]: "#FFFFFF",
  [COLORS.blackPrimary]: "#000000",
  [COLORS.highlightPrimary]: "#0000001A",
  [COLORS.ratePrimary]: "#E38218",
  [COLORS.grayPrimary]: "#9c9b9b",
  [COLORS.scrollerPrimary]: "#d0d8de",
}

export const DARK_PALETTE = {
  [COLORS.accentPrimary]: "#2194FF",
  [COLORS.successPrimary]: "#5BB849",
  [COLORS.dangerPrimary]: "#FF495C",
  [COLORS.warningPrimary]: "#FFB800",
  [COLORS.surfacePrimary]: "#000000",
  [COLORS.surfaceSecondary]: "#151E22",
  [COLORS.dividerPrimary]: "#3A4145",
  [COLORS.textPrimary]: "#FFFFFF",
  [COLORS.textSecondary]: "#9DA0A2",
  [COLORS.whitePrimary]: "#FFFFFF",
  [COLORS.blackPrimary]: "#000000",
  [COLORS.highlightPrimary]: "#FFFFFF1A",
  [COLORS.ratePrimary]: "#E38218",
  [COLORS.grayPrimary]: "#2a3437",
  [COLORS.scrollerPrimary]: "#4e5662",
}

